import { InferType, object } from 'yup';
import * as yup from 'yup';

export const changePasswordValidationSchema = object().shape({
  newPassword: yup
    .string()
    .required('Please enter a new password')
    .min(8, 'Password must be at least 8 characters long')
    .matches(/(?=.*[0-9])/, 'Password must contain a number'),
  currentPassword: yup.string().required('Please enter current password'),
  confirmNewPassword: yup
    .string()
    .required('Please confirm your new password')
    .oneOf([yup.ref('newPassword')], 'Passwords must match'),
});

export type ChangePasswordFormFields = InferType<
  typeof changePasswordValidationSchema
>;
